import { AttachmentCard } from './AttachmentCard'
import { CategoryContentCard as CategoryContent } from './CategoryContentCard'
import { ContentCard as Content } from './ContentCard'
import { ExcellenceProgramScoreCard as ExcellenceProgramScore } from './ExcellenceProgramScoreCard'
import { ExcellenceProgramSummaryCard as ExcellenceProgramSummary } from './ExcellenceProgramSummaryCard'
import { HighlightedContentCard as HighlightedContent } from './HighlightedContentCard'
import { OpportunitiesCard as Opportunities } from './NewOpportunities/OpportunitiesCard'
import { OpportunitiesListCard as OpportunitiesList } from './NewOpportunities/OpportunitiesListCard'
import { PoliciesCard as Policies } from './NewOpportunities/PoliciesCard'
import { NewsCard } from './NewsCard'
import { NotificationCard as Notification } from './NotificationCard'
import { OpportunityCard as Opportunity } from './OpportunityCard'
import { OpportunityOfCard } from './OpportunityOfCard'
import { OrganizationCard } from './OrganizationCard'
import { SummaryCard as Summary } from './SummaryCard'
import { SummaryDetailCard } from './SummaryDetailCard'
import { WalletCard } from './WalletCard'

export default {
  Content,
  HighlightedContent,
  Opportunity,
  OpportunityOfCard,
  Opportunities,
  OpportunitiesList,
  Policies,
  NewsCard,
  Notification,
  CategoryContent,
  OrganizationCard,
  Summary,
  WalletCard,
  AttachmentCard,
  SummaryDetailCard,
  ExcellenceProgramSummary,
  ExcellenceProgramScore
}
